
import Axios from "./CallerService"
export const login = (data) => {
    return Axios.post(`login`, data)
}